module.exports = __webpack_public_path__ + "img/category-keiri.b370897a.svg";